import { StoreState } from '@/core/models/store.interface';
import { SocialSecurityNumberMaskType } from '@nxtpeople/nxt-vue-library';
import { Module } from 'vuex';
import { SocialSecurityNumberMaskTypeService } from './social-security-number-mask-type.service';

const service = new SocialSecurityNumberMaskTypeService();

export interface SocialSecurityNumberMaskTypeState {
   socialSecurityNumberMaskTypes: Array<SocialSecurityNumberMaskType>;
}

const SocialSecurityNumberMaskTypeStore: Module<SocialSecurityNumberMaskTypeState, StoreState> = {
   namespaced: true,
   state: {
      socialSecurityNumberMaskTypes: [],
   },
   getters: {},
   mutations: {
      SET_SOCIAL_SECURITY_NUMBER_MASK_TYPES(state, maskTypes: Array<SocialSecurityNumberMaskType>) {
         state.socialSecurityNumberMaskTypes = maskTypes;
      },
   },
   actions: {
      async getSocialSecurityNumberMaskTypes(context) {
         const response = await service.getSocialSecurityNumberMaskTypes();
         context.commit('SET_SOCIAL_SECURITY_NUMBER_MASK_TYPES', response);
         return response;
      },
   },
};

export default SocialSecurityNumberMaskTypeStore;
